export default __webpack_public_path__ + "static/media/diamond.83dd9b4d.png";